import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { StockProviderListPage } from '../../stock/stock-provider-list/stock-provider-list';
import { StockListPage } from '../../stock/stock-list/stock-list';
import { DeliberyNoteListPage } from '../../delibery_note/delibery-note-list/delibery-note-list';
import { ProviderOrderListPage } from '../../providers/orders/provider-order-list/provider-order-list';
import { Globals } from '../../../globals';

/**
 * Generated class for the TopStockPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-top-stock',
  templateUrl: 'top-stock.html',
})
export class TopStockPage {
  @Input() type;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {

  }

  activeTab(value) {
    if (this.type == value) {
      let cssClasses = {
        'active': true,
        'nav-link': true,
        'space-norwap': true,
        'text-uppercase': true
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'active': false,
        'nav-link': true,
        'space-norwap': true,
        'text-uppercase': true
      }
      return cssClasses;
    }
  }

  onSelectTab(selectedTab: string) {
    switch (selectedTab) {
      case 'ingprod':
        this.openStockList();
        break;
      case 'providers':
        this.openProviersList()
        break
      case 'delibery':
        this.openDeliberyNotesList()
        break
      case 'orders':
        this.openProviderOrders()
        break
    }
  }





  openProviersList() {
    this.navCtrl.setRoot(StockProviderListPage);
  }
  openStockList() {
    this.navCtrl.setRoot(StockListPage);
  }
  openDeliberyNotesList() {
    this.navCtrl.setRoot(DeliberyNoteListPage);
  }
  openProviderOrders() {
    this.navCtrl.setRoot(ProviderOrderListPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/top-stock/top-stock.ts